import { Box, Heading } from '@chakra-ui/react'
import moment from 'moment';
import React from 'react'
import { Bar } from 'react-chartjs-2'

export default function CreditDebitBarChart({reportData}) {

    const groupedData = reportData?.Transactions?.reduce((acc, item) => {
        const month = moment(item.Date).format("MMMM YYYY");
        if (!acc[month]) {
            acc[month] = { Credit: 0, Debit: 0 };
        }
        acc[month].Credit += item.Credit;
        acc[month].Debit += item.Debit;
        return acc;
    }, {});

    const labels = groupedData && Object.keys(groupedData);
    const creditData = labels?.map((month) => groupedData[month].Credit);
    const debitData = labels?.map((month) => groupedData[month].Debit);

    const barChartData = {
        labels,
        datasets: [
            {
                label: "Credit",
                data: creditData,
                backgroundColor: "#357066",
            },
            {
                label: "Debit",
                data: debitData,
                backgroundColor: "#C2D6D3",
            },
        ],
    };

    const barChartOptions = {
        layout: {
            padding: {
                right: 15
            }
        },
        legend: {
            display: true,
            onClick: function (e, legendItem) {
                e.preventDefault();
                e.stopPropagation();
            },
            position: 'bottom',
            labels: {
                fontFamily: "Poppins",
                fontColor: '#000',
                fontSize: 12,
                fontStyle: 'normal',
                usePointStyle: true,
                padding: 30,
            },
        },
        tooltips: {
            position: 'nearest',
            backgroundColor: 'rgba(255,255,255,1)',
            titleFontColor: '#000',
            bodyFontColor: '#000',
            titleFontSize: 14,
            titleFontFamily: "Poppins",
            bodyFontFamily: "Poppins",
            bodyFontSize: 14,
            bodySpacing: 4,
            xPadding: 12,
            yPadding: 12,
            borderColor: '#D3D2D5',
            borderWidth: 1,
            displayColors: false,
            callbacks: {
                title: function (tooltipItem, data) {
                    return data.labels[tooltipItem[0].index]; // Display the label as the title
                },
                label: function (tooltipItem, data) {
                    const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    const formattedValue = value.toLocaleString('en-US');
                    return `(${'₹ ' + formattedValue + ''})`;
                }
            }
        },
        elements: {
            arc: {
                borderWidth: 0,
            },
        },
        scales: {
            yAxes: [{
                ticks: {
                    fontColor: "#000",
                    fontSize: 12,
                    fontFamily: "Poppins",
                    // stepSize: 1,
                    beginAtZero: true,
                    callback: function (value, index, values) {
                        return value.toLocaleString() + '';
                    }
                }
            }],
            xAxes: [{
                ticks: {
                    fontColor: "#000",
                    fontSize: 12,
                    fontFamily: "Poppins",
                }
            }],
        }
    };

    return (
        <Box className='investor_chart'>
            <Heading as="h2" className='font-poppins card_heading'>Monthly Credit & Debit</Heading>
            <Box mt={6}>
                <Bar options={barChartOptions} data={barChartData} />
            </Box>
        </Box>
    )
}
